import GenericSlider from "./generic_slider";

window.SBGenericSlider = GenericSlider;

window.addEventListener("DOMContentLoaded", () => {
    new window.SBGenericSlider('[data-generic-slider]');
});

